module.exports = __webpack_public_path__ + "img/w3_bookmark_white.b15ff870.png";